// @flow

import type { FlipState } from './types';
import {
  learningOrder,
} from '../types';

const initialState: FlipState = {
  events: [],
  answers: [],
  uniqueAnswers: {},
  cardStates: [
    {
      answerSeen: false,
      cardFlipped: false,
      confidenceProvided: false,
    },
  ],
  progressData: {
    target: [],
    answered: [],
    skipped: [],
  },
  answeredFacts: {},
  inReverseMode: false,
  currentIndex: 0,
  cardFlipped: false,
  lastSeenIndex: 0,
  flashCards: {
    termCards: [],
    factCards: [],
  },
  distribution: {
    high: 0,
    medium: 0,
    low: 0,
    none: 0,
  },
  contextId: null,
  sessionId: null,
  startTime: null,
  scheduleId: null,
  sessionCreated: false,
  endTime: null,
  summary: null,
  learningOrder: learningOrder.LINEAR,
  requestedQuestionsCount: 0,
  reviewedContents: [],
  hasMore: false,
  isSchedule: false,
  sessionMeta: {},
  isLastCardVisible: false,
};

export {
  // eslint-disable-next-line import/prefer-default-export
  initialState,
};
